/* eslint-disable */
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Validation } from '../../shared/services/validation.service';
import { ApplicationActions } from '../../actions/application.actions';
import { SelectOptionsService } from '../../shared/services/selectoptions.service';
import { FlowManagerService } from '../../shared/services/flowmanager.service';
import { NgRedux } from '@angular-redux/store';
import { ActivatedRoute } from '@angular/router';
import { InputPaths } from '../../shared/models/Enum/InputPaths';

@Component({
  selector: 'md-select',
  template: require('./select.component.html')
})

export class SelectComponent {
  @Input() options;
  @Input() showUp;
  @Input() isValid;
  @Output() valueChange = new EventEmitter();
  @Output() validCheck = new EventEmitter();
  @ViewChild('selectInput') selectInput;

  constructor(validation: Validation, appActions: ApplicationActions, optionsService: SelectOptionsService, ngRedux: NgRedux, flowmanager: FlowManagerService, route: ActivatedRoute) {
    this.validation = validation;
    this.appActions = appActions;
    this.optionsService = optionsService;
    this.flowManager = flowmanager;
    this.hasInit = true;
    this.selectedItem = 'Select';
    this.selectedId = '';
    this.ngRedux = ngRedux;
    this.init = false;
    this.isValid = true;
    this.form = route.data && route.data.value && route.data.value.formData;
    this.nonUSCitizen = false;
    this.residenceInputPath = null;

    this.validateSub = this.validation.validateInput.subscribe(() => this.triggerValidation());
  }

  ngOnInit() {
    if (this.options.optionsType !== undefined) {
      const year = this.flowManager.config.ira.currentTaxEndDate.split('/')[2];
      const selectOptions = this.optionsService.getSelectOptions(this.options.optionsType);
      if (this.options.optionsType === 'depositFrequencies' && this.appActions.getData('DepositFunds.contributionYear') < year) {
        this.options.options = selectOptions.filter(i => i.code === this.optionsService.optionTypes.frequency.ONE_TIME.code);
      } else {
        this.options.options = selectOptions;
      }
    }

    if (this.options.attr.inputClass === undefined) {
      this.options.attr.inputClass = 'dropdown-wrapper';
    }
    this.inputClass = this.options.attr.inputClass;

    if (this.options.defaultValue !== undefined) {
      this.selectedItem = this.options.defaultValue;

      const optName = this.optionsService.getCodeName(this.options.optionsType, this.selectedItem);
      const option = this.options.options.filter(opt => opt.name == optName)[0];
      if (option !== undefined) {
        this.selectedOption = option;
        this.selectedItem = option.name;
        this.selectedId = option.id;
      }
    }

    if (this.options.inputPath) {
      const arrayPath = this.options.inputPath.split('.');

      // residenceInputPath should only be set for the three paths below
      if (arrayPath[1] === 'citizenship'
        && (arrayPath[0] === InputPaths.CustodialMinorInformation
        || arrayPath[0] === InputPaths.JointAccountInformation
        || arrayPath[0] === InputPaths.PersonalInformation)
      ) {
        this.residenceInputPath = `${arrayPath[0]}.permanentResident`;
        const citizenship = this.appActions.getData(`${arrayPath[0]}.citizenship`);
        // BE/MW needs residence values and expects "true" for US citizens as well
        if (citizenship === 'US') {
          this.appActions.setData(this.residenceInputPath, true);
        } else {
          this.toggleResidencyDisplay(citizenship);
        }
      }

      arrayPath.unshift('applicationStore');
      this.arrayPath = arrayPath;

      if (this.options.inputPath.match(/\[\d+\]/) !== -1) {
        this.reduxObservable$ = this.ngRedux.select(state => _.get(state, `applicationStore.${this.options.inputPath}`));
      } else {
        this.reduxObservable$ = this.ngRedux.select(this.arrayPath);
      }

      this.reduxSubscription = this.reduxObservable$.subscribe(state => {
        this.currentValue = state;

        // Grab default from above
        if (this.init == false && state == null && this.selectedOption != null) {
          this.currentValue = this.selectedOption.name;
        }

        // Check if we actually need to do somthing
        if (this.currentValue != null || this.init === true) {
          // Translation for options that have values in service
          if (this.options.optionsType !== undefined) {
            this.currentValue = this.optionsService.getCodeName(this.options.optionsType, this.currentValue);
          }
          // Find the actual option in the list of options
          const option = this.options.options.filter(opt => opt.name == this.currentValue)[0];
          if (option != undefined) {
            this.selectedOption = option;
            this.selectedItem = option.name;
            this.selectedId = option.id;
          } else {
            this.selectedId = null;
            this.selectedItem = 'Select';
            this.selectedOption = null;
          }

          // Check validation on this, although I'm not sure we properly 'validate' but this is more for the 'required' stuff
          this.triggerValidation();

          // Pop it on up to the FormFactor (will be obsolete soon)
          const payload = {
            id: this.options.attr.id,
            validationType: this.options.validationType,
            value: this.currentValue,
            isValid: this.isValid,
            showHide: this.event
          };

          this.valueChange.emit(payload);

          if (this.init === false) {
            let setValue = this.currentValue;
            if (this.options.optionsType !== undefined) {
              setValue = this.optionsService.getCode(this.options.optionsType, this.currentValue);
            }
            this.appActions.setData(this.options.inputPath, setValue);
          } else {
            this.triggerValidation();
          }
        }

        this.init = true;
      });
    }
  }

  // set residency radio cards display; should only be called when this.residenceInputPath is set
  toggleResidencyDisplay(selectedCountry) {
    const nonUSCitizen = !!selectedCountry?.trim() && selectedCountry !== 'US';
    const residencyInput = this.form && this.form.inputs && this.form.inputs.residency;
    if (residencyInput) {
      this.form.inputs.residency.showUp = nonUSCitizen;
      this.form.inputs.residency.require = nonUSCitizen;
    }
  }

  ngOnDestroy() {
    if (this.validateSub) {
      this.validateSub.unsubscribe();
    }

    if (this.options.inputPath) {
      this.reduxObservable$.unsubscribe();
      this.reduxSubscription.unsubscribe();
    }
  }

  triggerValidation() {
    const isValidObj = this.validation.validate(this.options.validationType, this.selectedId || '');
    if (isValidObj !== undefined) {
      this.inputClass = this.inputClass.replace('error', '');
      this.isValid = isValidObj.state;
      if (!this.isValid) {
        this.options.msg = this.options.msg || {};
        this.options.msg.fail = isValidObj.msg;
        this.inputClass += ' error';
      }

      let isValid = this.isValid;
      if (this.showUp === false) {
        isValid = true;
      }
      this.validation.validCheck({
        id: this.options.attr.id,
        isValid: isValid
      });
      setTimeout(() => { // Ugh - due to a race condition between validation and show/hide. Must revisit
        if (this.showUp && !isValid) {
          this.selectInput.nativeElement.focus();
        }
      }, 250);
    }
  }

  onChange(event) {
    this.hasInit = false;
    this.selectedItem = event.name;
    this.selectedId = event.id;

    this.event = event;

    if (this.options.inputPath) {
      // capture previous country code (for citizenship & residency)
      const prevCountryCode = this.residenceInputPath && this.appActions.getData(this.options.inputPath);
      this.appActions.setData(this.options.inputPath, event.code || event.name);
      const year = this.flowManager.config.ira.currentTaxEndDate.split('/')[2];

      if (this.residenceInputPath) {
        if (event.code !== 'US' && prevCountryCode === 'US') {
          this.appActions.setData(this.residenceInputPath, null);
        } else if (event.code === 'US') {
          this.appActions.setData(this.residenceInputPath, true);
        }
        this.toggleResidencyDisplay(event.code);
      }

      if (this.options.inputPath === 'DepositFunds.frequency') {
        this.appActions.setData('DepositFunds.frequencyDisplay',
          this.optionsService.optionTypes.frequency[event.code || event.name].name);
      }
      if (this.options.inputPath === 'DepositFunds.contributionYear' && event.id < year) {
        this.appActions.setData('DepositFunds.frequency',
          this.optionsService.optionTypes.frequency.ONE_TIME.code);
        this.appActions.setData('DepositFunds.frequencyDisplay',
          this.optionsService.optionTypes.frequency.ONE_TIME.name);
      }
    } else {
      payload.value = event.code || event.name;
      this.valueChange.emit(payload);
    }
  }
}
